import {i18n} from '@netx/core/i18n';

export const getDocumentFileTypeAssetInfoLabel = (pageCount: number) =>
	// Do not display when there are no pages
	pageCount ? i18n.t('i18n.nPages', {count: pageCount}) : undefined;

export default getDocumentFileTypeAssetInfoLabel;
